import { Ptag } from "components/core";
import React from "react";
import { CoverageNotesList, CoverageDivWrapper } from "./styles";
import CircleIcon from "@mui/icons-material/Circle";
import { Box } from "@mui/material";
import exclusionsIcon from "../../../assets/svgs/exclusionIcon.svg";

function CoverageNotes({ title, notes }) {
  if (!notes) return null;
  // Filter out any empty strings from the notes array
  let filteredNotes = notes;
  if (notes instanceof String) {
    filteredNotes = notes.filter((note) => note.trim() !== "");
  }

  // Return null if the filteredNotes array is empty
  if (filteredNotes.length === 0) {
    return null;
  }

  function containsHeadingKey(array) {
    return (
      Array.isArray(array) &&
      array.some(
        (item) => item && typeof item === "object" && "heading" in item
      )
    );
  }

  return (
    <div>
      <Ptag
        color="rgba(46, 7, 64, 1)"
        fontWeight="400"
        fontSize="28px"
        marginTop="64px"
        marginBottom="24px"
        lineHeight="20px"
        fontFamily="Instrument Serif"
      >
        {title}
      </Ptag>
      <CoverageNotesList>
        {!containsHeadingKey(notes)
          ? notes.map((note) => (
              <li key={note}>
                <Ptag fontSize="16px" fontWeight="400">
                  {note}
                </Ptag>
              </li>
            ))
          : notes.map((note, key_x) => (
              <CoverageDivWrapper key={key_x}>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "14px" }}
                >
                  {/* <div>
                    <CircleIcon sx={{ fontSize: "8px", color: "#4A4A4A" }} />
                  </div> */}
                  <Box sx={{ position: "relative", top: "2.5px"}}>
                    <Ptag>
                      <img src={exclusionsIcon} alt="exclusionsIcon.png" />
                    </Ptag>
                  </Box>
                  <div>
                    {/* <Ptag
                      fontSize="18px"
                      fontWeight="600"
                      marginBottom="2px"
                      color="#4A4A4A"
                    >
                      {note.heading}
                    </Ptag> */}
                    <Ptag fontSize="16px" fontWeight="500" color="#4A4A4A">
                      {note.description}
                    </Ptag>
                  </div>
                </Box>
              </CoverageDivWrapper>
            ))}
      </CoverageNotesList>
    </div>
  );
}

export default CoverageNotes;